<template>
  <div class="flex flex-row items-center gap-3">
    <div class="relative w-[18px] h-[18px]">
      <input
        type="checkbox"
        :id="id"
        v-model="model"
        class="appearance-none w-[18px] h-[18px] rounded-extra-small bg-transparent border-2 border-on-surface-variant checked:bg-primary checked:border-primary cursor-pointer"
      />
      <BaseIcon
        size="18"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-on-primary invisible pointer-events-none"
        :class="[model && 'visible']"
        >check</BaseIcon
      >
    </div>
    <label :for="id" class="select-none text-body-large text-on-surface-variant cursor-pointer"
      ><slot
    /></label>
  </div>
</template>
<script setup lang="ts">
import { useId } from 'vue'
import BaseIcon from '../icon/BaseIcon.vue'

const model = defineModel<boolean>({ default: false })

const id = useId()
</script>
